import { parseApiDate } from "@/helpers/daysLeft";

export const REMINDER_DAYS_BEFORE = 5;
export const MONTHLY_PERIOD = 2;
export const YEARLY_PERIOD = 3;

export const featureHeadline = (feature, wantListingTitle) => {
  if (feature === "video") {
    return wantListingTitle
      ? `Add a video to “${wantListingTitle}”`
      : "Add video to your Buyer Want‑Listings";
  }
  if (feature === "buyerForm") return "Put a buyer listing form on your bio";
  if (feature === "shareCard") return "Share your Buyer Want‑Listings with your photo and logo";
  return "Get found. Get chosen. Get clients.";
};

export const glueLast = (text) => String(text || "").replace(/ (\S+)$/, "\u00a0$1");

export const featureWhy = (feature) => {
  if (feature === "video") return "Videos come with Gitcha Pro, along with a buyer listing form on your bio and branded share cards.";
  if (feature === "buyerForm") return "The form comes with Gitcha Pro, along with videos on your Buyer Want‑Listings and branded share cards.";
  if (feature === "shareCard") return "Branded share cards come with Gitcha Pro, along with a buyer listing form and videos.";
  return "Gitcha Pro adds a buyer listing form to your bio, videos on your Buyer Want‑Listings and branded share cards.";
};

const DAY_MS = 24 * 60 * 60 * 1000;

export const shortDay = (date) =>
  date ? date.toLocaleDateString("en-US", { month: "short", day: "numeric" }) : null;

export const longDay = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : parseApiDate(value);
  return Number.isNaN(date?.getTime?.()) ? null : date.toLocaleDateString("en-US", { month: "long", day: "numeric" });
};

export const trialSteps = ({ now = new Date(), trialDays, price }) => {
  if (!trialDays || !price) return [];
  const end = new Date(now.getTime() + trialDays * DAY_MS);
  const reminder = new Date(end.getTime() - REMINDER_DAYS_BEFORE * DAY_MS);
  return [
    { key: "today", when: "Today", what: "No card needed" },
    { key: "reminder", when: shortDay(reminder), what: "Reminder email" },
    { key: "billed", when: shortDay(end), what: `Then ${price} a month` },
  ];
};

export const proStage = (offerState, pkg, plansQuery) => {
  if (pkg?.status === "covered") return "covered";
  if (offerState === "pro" || offerState === "kept") {
    // A brokerage-covered agent also reads as Pro until the plans arrive, so wait for them.
    if (plansQuery && !plansQuery.data) return plansQuery.isError ? "error" : "loading";
    return "pro";
  }
  return offerState;
};

export const canAskBroker = (plans, stage) => {
  const brokerage = plans?.audience?.brokerage;
  if (!brokerage?.onGitcha || !brokerage?.name) return false;
  return stage === "offer" || stage === "upgrade" || stage === "trial";
};

export const keepPeriods = (offer) => {
  if (!offer?.onTrial) return ["month", "year"];
  return Array.isArray(offer.keepPeriods) && offer.keepPeriods.includes("year") ? ["month", "year"] : ["month"];
};

// A yearly price only counts as an option when it costs less than twelve
// months, and the label says how many months that saves (never a made-up "2").
export const yearlyOption = (monthly, yearly) => {
  const month = Number(monthly);
  const year = Number(yearly);
  if (!(month > 0) || !(year > 0) || year >= month * 12) return null;
  const free = Math.round((month * 12 - year) / month);
  return { label: free >= 1 ? `Yearly, ${free} ${free === 1 ? "month" : "months"} free` : "Yearly" };
};

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

export const usageLine = (usage) => {
  if (!usage) return null;
  const parts = [
    usage.buyerFormsReceived ? plural(usage.buyerFormsReceived, "buyer form sent to you", "buyer forms sent to you") : null,
    usage.videosAdded ? plural(usage.videosAdded, "video added", "videos added") : null,
    usage.shareCardsMade ? plural(usage.shareCardsMade, "share card made", "share cards made") : null,
  ].filter(Boolean);
  if (!parts.length) return null;
  const list = parts.length > 1 ? `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}` : parts[0];
  return `During your trial: ${list}.`;
};
